import { tweet } from "./tweet";

export default tweet;

export { tweet as renderTweet };
